import type { AddressDto } from '../types/salesOrder.types';

interface Props {
  /** The selected address from the customer's address book, or undefined. */
  address: AddressDto | undefined;
  /** Section caption shown above the block. */
  label?: string;
}

// Read-only echo of the full structured value of a selected saved address.
// NetSuite's UI shows the complete assembled address block beneath the picker so
// the user can verify exactly what will post; the dropdown trigger only shows a
// short label. `addrText` is NetSuite's multi-line concatenated address (it
// already includes the country line), so we render it verbatim. Renders nothing
// when there's no selection or no text to show.
//
// 86d39epjt — "attached" variant: no border/background of its own. It now renders
// inside an AddressCard (which provides the boundary + divider), so the previous
// standalone gray box would double-up the chrome. Both call sites (shipping picker
// + billing column) live inside a card.
export function AddressPreview({ address, label = 'Selected address' }: Props) {
  const text = address?.addrText?.trim() || address?.addressee?.trim() || '';
  if (!text) return null;

  return (
    <div className="space-y-0.5">
      <span className="text-xs uppercase tracking-wide text-muted-foreground">{label}</span>
      <div className="whitespace-pre-line text-sm text-foreground">{text}</div>
    </div>
  );
}
